import { ItiLink as Link } from 'components';
import { DataTableColumn } from 'components/tables/data-table';

export const getRowName = (row: any, col: DataTableColumn) => {
  return row?.[col.field]?.['name'];
};

export const transactionActivityDataColumns: DataTableColumn[] = [
  {
    width: 80,
    field: 'timestamp',
    label: 'DATE',
    type: 'dateTime',
    getValueLabel: v =>
      !!v ? new Date(v).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }).replace(',', '') : null
  },
  {
    width: 144,
    field: 'action',
    label: 'ACTION'
  },
  {
    width: 144,
    field: 'modifiedBy',
    label: 'USER'
  },
  {
    width: 300,
    field: 'description',
    label: 'DESCRIPTION',
    renderCell: (_, row) => row.description
  },
  {
    width: 144,
    field: 'booking',
    label: 'BOOKING',
    renderCell: bookingId => (bookingId === 'N/A' ? <p>N/A</p> : <Link to={`/bookings/${bookingId}`}>{bookingId}</Link>)
  }
];
